import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  InputBase,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";

import dataCDMX from "../components/jsonBD/CiudadDeMexico.json";
import dataYucatan from "../components/jsonBD/Yucatan.json";
import dataQuintanaRoo from "../components/jsonBD/QuintanaRoo.json";
import dataAguascalientes from "../components/jsonBD/Aguascalientes.json";
import dataBajaCaliforniaSur from "../components/jsonBD/BajaCaliforniaSur.json";
import dataBajaCalifornia from "../components/jsonBD/BajaCalifornia.json";
import dataCampeche from "../components/jsonBD/Campeche.json";
import dataChiapas from "../components/jsonBD/Chiapas.json";
import dataChihuahua from "../components/jsonBD/Chihuahua.json";
import dataCoahuila from "../components/jsonBD/Coahuila.json";
import dataColima from "../components/jsonBD/Colima.json";
import dataDurango from "../components/jsonBD/Durango.json";
import dataEstadoDeMexico from "../components/jsonBD/EstadoDeMexico.json";
import dataGuanajuato from "../components/jsonBD/Guanajuato.json";
import dataGuerrero from "../components/jsonBD/Guerrero.json";
import dataHidalgo from "../components/jsonBD/Hidalgo.json";
import dataJalisco from "../components/jsonBD/Jalisco.json";
import dataMichoacan from "../components/jsonBD/Michoacan.json";
import dataMorelos from "../components/jsonBD/Morelos.json";
import dataNayarit from "../components/jsonBD/Nayarit.json";
import dataNuevoLeon from "../components/jsonBD/NuevoLeon.json";
import dataOaxaca from "../components/jsonBD/Oaxaca.json";
import dataPuebla from "../components/jsonBD/Puebla.json";
import dataQueretaro from "../components/jsonBD/Queretaro.json";
import dataSanLuisPotosi from "../components/jsonBD/SanLuisPotosi.json";
import dataSinaloa from "../components/jsonBD/Sinaloa.json";
import dataSonora from "../components/jsonBD/Sonora.json";
import dataTabasco from "../components/jsonBD/Tabasco.json";
import dataTamaulipas from "../components/jsonBD/Tamaulipas.json";
import dataTlaxcala from "../components/jsonBD/Tlaxcala.json";
import dataVeracruz from "../components/jsonBD/Veracruz.json";
import dataZacatecas from "../components/jsonBD/Zacatecas.json";

const drawerWidth = 240;

function Navbar() {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState("");

  const navigate = useNavigate();

  const handleItemClick = (estado) => {
    setDrawerOpen(false);
    setSelectedEstado(estado);
  };

  const toggleDrawer = () => {
    if (!isDrawerOpen) {
      setScrollPosition(window.scrollY);
    }
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      window.scrollTo(0, scrollPosition);
    }
  }, [isDrawerOpen, scrollPosition]);

  const estadosDeMexico = [
    "Aguascalientes",
    "Baja California",
    "Baja California Sur",
    "Campeche",
    "Chiapas",
    "Chihuahua",
    "Ciudad de México",
    "Coahuila",
    "Colima",
    "Durango",
    "Estado de México",
    "Guanajuato",
    "Guerrero",
    "Hidalgo",
    "Jalisco",
    "Michoacan",
    "Morelos",
    "Nayarit",
    "Nuevo León",
    "Oaxaca",
    "Puebla",
    "Querétaro",
    "Quintana Roo",
    "San Luis Potosí",
    "Sinaloa",
    "Sonora",
    "Tabasco",
    "Tamaulipas",
    "Tlaxcala",
    "Veracruz",
    "Yucatán",
    "Zacatecas",
  ];

  // 🔥 Unir todos los JSON en un solo array
  const mapState = (data, state) => {
    return data.map((item) => ({
      ...item,
      estado: state,
      uniqueKey: item.id + "_" + item.title, // Creamos una clave única usando el id y el título
    }));
  };

  const allData = [
    ...mapState(dataCDMX, "Ciudad de México"),
    ...mapState(dataYucatan, "Yucatán"),
    ...mapState(dataQuintanaRoo, "Quintana Roo"),
    ...mapState(dataAguascalientes, "Aguascalientes"),
    ...mapState(dataBajaCaliforniaSur, "Baja California Sur"),
    ...mapState(dataBajaCalifornia, "Baja California"),
    ...mapState(dataCampeche, "Campeche"),
    ...mapState(dataChiapas, "Chiapas"),
    ...mapState(dataChihuahua, "Chihuahua"),
    ...mapState(dataCoahuila, "Coahuila"),
    ...mapState(dataColima, "Colima"),
    ...mapState(dataDurango, "Durango"),
    ...mapState(dataEstadoDeMexico, "Estado de México"),
    ...mapState(dataGuanajuato, "Guanajuato"),
    ...mapState(dataGuerrero, "Guerrero"),
    ...mapState(dataHidalgo, "Hidalgo"),
    ...mapState(dataJalisco, "Jalisco"),
    ...mapState(dataMichoacan, "Michoacan"),
    ...mapState(dataMorelos, "Morelos"),
    ...mapState(dataNayarit, "Nayarit"),
    ...mapState(dataNuevoLeon, "Nuevo León"),
    ...mapState(dataOaxaca, "Oaxaca"),
    ...mapState(dataPuebla, "Puebla"),
    ...mapState(dataQueretaro, "Querétaro"),
    ...mapState(dataSanLuisPotosi, "San Luis Potosí"),
    ...mapState(dataSinaloa, "Sinaloa"),
    ...mapState(dataSonora, "Sonora"),
    ...mapState(dataTabasco, "Tabasco"),
    ...mapState(dataTamaulipas, "Tamaulipas"),
    ...mapState(dataTlaxcala, "Tlaxcala"),
    ...mapState(dataVeracruz, "Veracruz"),
    ...mapState(dataZacatecas, "Zacatecas"),
  ];

  // Ahora `allData` tendrá cada elemento con su correspondiente estado añadido

  console.log("allData"); // Esto te muestra todos los datos
  console.log(allData.map((item) => item.title)); // Esto te muestra todos los títulos

  useEffect(() => {
    console.log("Buscando: ", searchQuery);

    if (searchQuery.trim() === "") {
      setSearchResults([]);
      return;
    }

    const queryLower = searchQuery.toLowerCase().trim();
    const regex = new RegExp(queryLower, "i");

    const results = allData.filter((item) => {
      const title = item.title.toLowerCase().trim();
      return regex.test(title);
    });

    console.log("Resultados encontrados: ", results);
    setSearchResults(results);
  }, [searchQuery]);

  const handleSelectItem = (title, estado) => {
    navigate(`/${estado}`);
    setSearchQuery(""); // Limpiar búsqueda después de seleccionar
    setSearchResults([]); // Ocultar resultados
  };

  return (
    <React.Fragment>
      <AppBar position="fixed" sx={{ backgroundColor: "var(--top-bar-color)" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            BeyondTacos
          </Typography>

          {/* 🔎 Barra de búsqueda */}
          <Paper
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: 150, md: 250 }, // Ancho responsivo: 150px en móviles (xs), 250px en pantallas md y superiores              borderRadius: 5,
              padding: "2px 4px",
              backgroundColor: "white",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Buscar platillo..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <IconButton type="button" sx={{ p: "10px" }}>
              <SearchIcon />
            </IconButton>
          </Paper>
        </Toolbar>
      </AppBar>

      {/* 🔽 Dropdown con los resultados */}
      {/*  {searchResults.length > 0 && (
        <div
          style={{
            position: "fixed",
            top: "64px", // Ajusta la posición superior
            right: "10px",
            width: "250px",
          }}
        >
          <ul
            style={{
              background: "white",
              listStyle: "none",
              padding: "10px",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
              borderRadius: "5px",
              maxHeight: "200px",
              overflowY: "auto",
              zIndex: 9999,
            }}
          >
            {searchResults.map((item) => (
              <li
                key={item.uniqueKey} // Utilizamos la nueva clave única
                onClick={() => handleSelectItem(item.title, item.estado)} // Pasamos el estado correspondiente
                style={{
                  cursor: "pointer",
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {item.title}
              </li>
            ))}
          </ul>
        </div>
      )} */}

      {searchResults.length > 0 && (
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            top: { xs: "56px", sm: "64px" }, // Ajuste según altura del AppBar
            right: { xs: "10px", md: "20px" },
            // width: { xs: "calc(100% - 20px)", sm: "300px", md: "350px" },
            width: { xs: 150, md: 250 },
            maxWidth: "90vw",
            zIndex: 1300, // ⬅️ Mayor que AppBar (1100) y Drawer (1200)
            maxHeight: "400px",
            overflowY: "auto",
            backgroundColor: "white",
          }}
        >
          <List sx={{ padding: 0 }}>
            {searchResults.map((item) => (
              <React.Fragment key={item.uniqueKey}>
                <ListItem
                  button
                  onClick={() => handleSelectItem(item.title, item.estado)}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                    padding: "12px 16px",
                  }}
                >
                  <ListItemText
                    primary={item.title}
                    secondary={item.estado}
                    primaryTypographyProps={{
                      fontWeight: 500,
                    }}
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      )}

      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={toggleDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "var(--left-menu-color)",
          },
        }}
      >
        <div style={{ width: drawerWidth, backgroundColor: "white" }}>
          <IconButton onClick={toggleDrawer} style={{ float: "right" }}>
            <ChevronLeftIcon />
          </IconButton>
        </div>

        <Divider />
        <List>
          <ListItem
            button
            component={NavLink}
            to="/"
            onClick={() => handleItemClick("Home")}
          >
            <ListItemIcon sx={{ color: "white" }}>
              <HomeIcon />
            </ListItemIcon>
          </ListItem>

          <Divider />

          {estadosDeMexico.map((estado, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                component={NavLink}
                to={`/${estado}`}
                onClick={() => handleItemClick(estado)}
                sx={{
                  backgroundColor:
                    selectedEstado === estado ? "#006847" : "initial",
                  color: selectedEstado === estado ? "white" : "initial",
                }}
              >
                <ListItemText primary={estado} sx={{ color: "white" }} />
              </ListItem>
              {index < estadosDeMexico.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Drawer>
    </React.Fragment>
  );
}

export default Navbar;
